const stats = (state) => state.stats;

export default {
  stats,
};
